/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionRejectWorkflow';

const ActionRejectWorkflowManager: ActionManagerFn<'ActionRejectWorkflow'> = (
  platform: Platform,
): ActionManager<'ActionRejectWorkflow'> => {
  return {
    ...baseActionManager(platform, 'ActionRejectWorkflow'),
    isChildAllowed: (page, item, childType) =>
      ['ActionOnResponse'].includes(childType),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Reject Workflow',
    replaceableWith: ['ActionApproveWorkflow'],
    icon: { iconName: 'file-times' },
    description: `Use this action to reject a workflow. This action will only work when the page is opened via. the link generated by wf.pageUrlForApproval() call used in the Approval node.

User will be prompted to provide a reason for rejection.

#### On Response

Use \`On Response\` child action to perform further actions after receiving the response from reject workflow call.

\`\`\`javascript
// The JSON Object from the server will be available as $._.response, which contains the following attributes
approvalStatus, // 'Rejected',
approver, // Approver's userName,
executionId,
nodeId,
nodeType,
rejectReason, // The rejection reason provided by the user
version, // Workflow UID
wfInstUid, // Workflow Instance UID
wfUid, // Workflow UID
// Sample expression using the above values sent by the server
\`\${$._.response.approvalStatus} \${$._.response.approver}!\`
\`\`\`
`,
  };
};

export default ActionRejectWorkflowManager;
